import MalekImage from "./Malek.jpg"
import Sun from './Muha.jpg'
export const Team = () => {
    return (
        <section id="Teem">
            <h2>Our Teem</h2>
            <div id="wd-teem-bl">
                <div className="person-bl">
                    <img src={MalekImage} alt="" className="malek_img"/>
                    <h4>Barber Malek</h4>
                    <p>With 20+ years of experience, Barber Malek delivers exceptional service. Specializing in fades, line-ups, and straight blade shaves, he offers personalized consultations for diverse clientele. Malek's expertise covers classic shaves, threading, and modern trends like undercuts. Using clippers and scissors, he crafts precise and stunning hair transformations. Elevate your style with Barber Malek's unmatched talent.</p>
                </div>

                <div className="person-bl">
                <img src={Sun} alt="" className="malek_img"/>
                    <h4>Barber Muhammend</h4>
                    <p>Barber Muhammed, with three years of experience, has become a true master of his craft. His haircutting skills are impeccable, as he excels in executing flawless fades and creating any hairstyle that you prefer. With his extensive knowledge of the latest trends and techniques, combined with his attention to detail, you can trust him to deliver the perfect haircut every time. Whether you're looking for a classic, clean-cut style or a bold, avant-garde look, Barber Muhammed will work his magic to ensure you leave his chair feeling confident and satisfied.</p>
                </div>
            </div>
        </section>
    );
}